import { render, staticRenderFns } from "./capitalManage-detail.vue?vue&type=template&id=23cd1960&"
import script from "./capitalManage-detail.vue?vue&type=script&lang=js&"
export * from "./capitalManage-detail.vue?vue&type=script&lang=js&"
import style0 from "./capitalManage-detail.vue?vue&type=style&index=0&id=23cd1960&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports